import { tosContent } from './content';

export function TosFooter() {
  return (
    <footer className="tos-footer">
      {tosContent.map((row, rowIndex) => (
        <div key={rowIndex}>
          <p>
            {row.map((item, itemIndex) => (
              <span key={itemIndex}>
                {item.href ? <a href={item.href}>{item.text}</a> : item.text}
              </span>
            ))}
          </p>
        </div>
      ))}
    </footer>
  );
}
